import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchCatalogItemById,
  pushEventsLog,
  saveCart,
  saveProductLoaderId,
  // setChooseAndRepeatModalVisibility,
  setSelectedVariantModalVisibility,
  setVariantModalVisibility,
} from 'src/redux/actions';
import {
  AmountActual,
  AmountDiscounted,
  CardContainer,
  CardBody,
  ButtonContainer,
  CardData,
  CardDescription,
  CardDiscount,
  CardImage,
  CardMain,
  CardPrice,
  CardTitle,
  Button,
  CardTags,
  CardTag,
  CardInventory,
  CardDescriptionMock,
} from './Card.styles';
import { checkForLimitedQuantity } from '@/utils/checkForLimitedQuantity';
import { itemQuantityValueComparison } from '@/utils/itemQuantityValueComparison';
import { deviceWidth } from '@/utils/deviceWidth';
import { scrollItemAndRemoveDetails } from '@/utils/scrollItemAndRemoveDetails';
import { getStoreType } from '@/utils/getStoreType';
import { getDiscountPercentage } from '@/utils/getDiscountPercentage';
import { toastNotifyInfo } from '@/components/Common/Toast';
import RatingBox from '../../RatingBox';
import {
  ITEM_ACTIVE_STATUS,
  MAX_MOBILE_WIDTH,
  STORE_CUSTOMIZATION,
} from '@/utils/constants';
import { useFeatureLocks } from '@/hooks/useFeatureLocks';
import { useSetWishlistState } from 'src/hooks/useSetWishlistState';
import { useSSRSelector } from '@/redux/ssrStore';
import {
  componentTypeEnums,
  getImageUrlFromCompressedImages,
  getMaxImgSizeForComponent,
} from '@/utils/compressedImagesHelpers';
import { mutateItemObjectWithCartData } from '@/utils/mutateItemObjectWithCartData';
import { Link } from '@/components/Link';
import { useItemClick } from '@/hooks/useItemClick';
import { canShowPDPSystem } from '@/utils/canShowPDPSystem';
import { openProductPersonalizationPopUp, savePDPData } from '@/redux/actions';
import { useCartHandlers } from '@/hooks/useCartHandler';
import OfferAvailableTag from '@/components/CouponsAndVouchers/OfferAvailableTag';
import { hexToRgba } from '../ModernTheme/utils/common';
import { IS_SERVER } from '@/utils/checkRenderEnv';
import { getRoute } from '@/utils/routes';
import { MediaContainer } from '@/components/ProductMediaRenderer/MediaContainer';
import { RootState } from '@/redux/reducers';
import { useGetDeviceType } from '@/hooks/useGetDeviceType';
import { useWidgetDndContextData } from '@/context/WidgetDndContext';
import { NextImage } from '../NextImage';
import CloseIconWhiteBackground from "@/assets/svgExports/CloseIconWhiteBackground";
import WishlistHeartButton from '@/components/Wishlist/WishlistHeartButton';
import { ITEM_WISHLIST_STATE } from 'src/constants/wishlist';
import { isNotifyProductEnabled } from 'src/utils/isNotifyProductEnabled';

export const Card = (props) => {
  const {
    data = {},
    // productCard = false,
    showCategoryCard = false,
    imageUrl = 'https://picsum.photos/300/300',
    noTags: noTagsFromProps = true,
    noTagsReadState = 'fromProp',
    skeleton,
    skeletonImage,
    cardWidth = undefined,
    isWishlistCard = false,
    onWishlistDeleteClick = undefined,
  } = props;

  const {
    widgetContextState: { previewDevice, isBuilder },
  } = useWidgetDndContextData();

  const { deviceType } = useGetDeviceType();
  const isMobile = isBuilder ? previewDevice === 'mobile' : deviceType === 'mobile';

  const { theme, store_id, services, premium } = useSSRSelector(
    (state) => state.storeReducer.store
  );

  const [onItemClick, getLink] = useItemClick();
  const dispatch = useDispatch();
  const cartData = useSelector((state: RootState) => state.cartReducer);
  const { storeInfo, oosStatus, storeData } = useSSRSelector((state) => {
    const storeData = state.storeReducer.store;
    return {
      storeInfo: storeData,
      storeData,
      oosStatus: (storeData?.services as any)?.hide_out_of_stock,
    };
  });

  const { userData, reviewSettings } = useSelector((state: RootState) => ({
    userData: state.userReducer,
    reviewSettings: state.catalogReducer.reviewSettings,
  }));
  const [discountPercent, setDiscountPercent] = useState(0);
  const [isItemWishlisted, setIsItemWishlisted] = useState(data?.item_whislisted);
  const { crrFeatureStatus } = useFeatureLocks();
  const { setWishlistState } = useSetWishlistState();
  const isB2bStore = getStoreType(storeData) === STORE_CUSTOMIZATION.B2B;

  const {
    handleSetProductCustomizationCount,
    handleSetProductData,
    handleIncreamentClick,
    handleDecreamentClick,
  } = useCartHandlers();

  const hasVariant = props.data?.variants_count > 0;
  const itemIndexInCart = cartData?.items?.findIndex(
    (el) => (el.id || el.item_id) === data?.id
  );

  const hasScheduler = !!props.data?.item_schedule;

  useEffect(() => {
    if (data && data?.is_active !== ITEM_ACTIVE_STATUS.HIDDEN) {
      const percent = getDiscountPercentage(data?.price, data?.discounted_price);
      setDiscountPercent(percent ? percent : 0);
      scrollItemAndRemoveDetails(data, cardRef);
      setIsItemWishlisted(data?.item_whislisted);
    }
  }, [data]);

  const noTags = (function () {
    switch (noTagsReadState) {
      case 'fromProp':
        return noTagsFromProps;
      case 'fromLength':
        return !data?.tags?.length;
      default:
        return noTagsFromProps;
    }
  })();

  const cardRef = useRef(null);

  const product_aspect_ratio =
    theme && theme.product_aspect_ratio !== 0
      ? parseFloat((theme?.product_aspect_ratio / 100 || 0) as any).toFixed(3)
      : 1;

  if (skeleton) {
    return (
      <CardContainer imageUrl={'skeleton'}>
        {skeletonImage && (
          <NextImage
            src={skeletonImage}
            height={
              isMobile
                ? data?.thumbnail_url
                  ? `calc(((100vw - 60px) / 2)/${
                      props.product_aspect_ratio !== 0 ? props.product_aspect_ratio : 1
                    });`
                  : 'auto'
                : data?.thumbnail_url
                  ? `calc(200px/${product_aspect_ratio !== '0' || (product_aspect_ratio as any) == 0 ? product_aspect_ratio : 1})`
                  : '180px'
            }
            width={cardWidth}
            layout="fill"
            quality={isMobile ? 40 : 100}
            loading="lazy"
            decoding="async"
          />
        )}
        {!skeletonImage && (
          <CardBody>
            <CardImage>
              <div
                style={{ width: '100%', height: '100%' }}
                className="skeleton br3"
              ></div>
            </CardImage>
            <CardMain imageUrl="skeleton" padding={'4px 0 0'}>
              <CardData>
                {!noTags && (
                  <CardTags padding="8px 0 0px">
                    <CardTag className="skeleton">Tag Name</CardTag>
                    <CardTag className="skeleton">Tag</CardTag>
                  </CardTags>
                )}
                <CardTitle categoryCard={showCategoryCard}
                              isWishlistCard={isWishlistCard}>
                  <CardDescriptionMock className="skeleton br3">
                    Loading Product Name Mock
                  </CardDescriptionMock>
                  <CardDescriptionMock className="skeleton br3">
                    Product Name
                  </CardDescriptionMock>
                </CardTitle>
                {!showCategoryCard && (
                  <CardPrice>
                    <AmountDiscounted
                      fontColor={
                        props.builderOverrideStyles?.textColor ||
                        theme?.colors?.primary_color
                      }
                      className="skeleton br3"
                    >
                      ₹ 0
                    </AmountDiscounted>
                  </CardPrice>
                )}
              </CardData>
            </CardMain>
            <div className={premium === 0 && 'ph2 pb2'}>
              <CardDescription>
                <CardDescriptionMock className="skeleton br3">
                  Description Demo
                </CardDescriptionMock>
                <CardDescriptionMock className="skeleton br3">
                  Description Demo Content
                </CardDescriptionMock>
                <CardDescriptionMock className="skeleton br3">
                  Description
                </CardDescriptionMock>
              </CardDescription>
            </div>
          </CardBody>
        )}
      </CardContainer>
    );
  }

  if (data?.is_active === ITEM_ACTIVE_STATUS.HIDDEN) return null;

  const handleAddRemoveItem = (type) => {
    if ((type === "OOS" || hasScheduler) && isWishlistCard) { // out of stock redirect to pdp page (this is case of notify me cta on wishlist card)
      onItemClick(data);
      return ;
    }
    dispatch(
      pushEventsLog({
        event_name: 'Cx_ATC',
        data: {
          store_id: storeInfo?.store_id,
          domain: storeInfo?.store_info?.domain,
          page: window.location.href,
          device: deviceWidth <= MAX_MOBILE_WIDTH ? 'Mobile' : 'Desktop',
          cx_number: userData?.data?.phone,
        },
      })
    );
    const productItem = cartData.items[itemIndexInCart];

    // managed_inventory !== 0. available_quantity !== 0.
    // don't proceed to control flow if available_quantity is 0
    if (type === 'inc' && itemQuantityValueComparison(productItem)) {
      toastNotifyInfo('No more units available for purchase');
      return;
    }
    /** Check if variant present in this item */
    if (hasVariant) {
      dispatch(saveProductLoaderId(props.data?.id));
      dispatch(savePDPData(props?.data));
      /** check if item exist in cart */
      if (itemIndexInCart !== -1) {
        switch (type) {
          case 'inc':
            dispatch(setVariantModalVisibility(true));
            break;
          case 'dec':
            dispatch(setSelectedVariantModalVisibility(true));
            break;
        }
      } else {
        /** get the details item for this item id */
        dispatch(
          fetchCatalogItemById(
            { store_id: store_id, item_id: props.data?.id, src: 'design_system_card' },
            true,
            (data) => {
              handleSetProductData(data);
            }
          )
        );
      }
    } else {
      if (data?.product_personalization) {
        handleSetProductCustomizationCount(data);
        dispatch(savePDPData(data));
        handleSetProductData(data);
        switch (type) {
          case 'add':
            dispatch(openProductPersonalizationPopUp());
            break;
          case 'inc':
            handleIncreamentClick(type, data);
            break;
          case 'dec':
            handleDecreamentClick(type, data);
            break;
          default:
            break;
        }
      } else {
        const newState = mutateItemObjectWithCartData(type, data, cartData);
        dispatch(saveCart(newState));
      }
    }
  };

  // function to remove all anchor tags from string
  function removeTagsAndReturn(str) {
    if (IS_SERVER) return str;
    const tmp = document.createElement('div');
    // add string to created div as html
    tmp.innerHTML = str;
    // get all anchor tags added to created element
    const anchor_tag_collection = tmp.getElementsByTagName('a');
    // iterate over all the tags and remove them from the HTML collection
    if (anchor_tag_collection.length) {
      // convert HTML collection to array
      Array.from(anchor_tag_collection).forEach(function (tag) {
        // remove the tags
        if (tag) {
          tag.parentNode.removeChild(tag);
        }
      });
    }
    return tmp.textContent || tmp.innerText || '';
  }

  const handleToggleWishlistClick = (id: number) => {
    const payload = {
        item_id: id,
        status: isItemWishlisted ? ITEM_WISHLIST_STATE.REMOVE_FROM_WISHLIST : ITEM_WISHLIST_STATE.ITEM_WISHLISTED
    }
    setWishlistState(payload, (status) => {
      if (status) {
        setIsItemWishlisted((prev) => !prev);
      }
    });
  }

  const hasRating =
    !crrFeatureStatus?.isLocked &&
    reviewSettings?.status &&
    data?.store_item_review_rating?.review_rating &&
    data?.store_item_review_rating?.review_rating[0]?.avg_rating;

  const cardImageUrl = theme?.custom_theme_flag ? data?.image_url : data?.thumbnail_url;
  const compressedImages =
    Array.isArray(data?.images) &&
    data?.images.length > 0 &&
    data?.images[0]?.compressed_images;

  const renderCard = () => {
    const showDiscount = !showCategoryCard && discountPercent > 0 && !isB2bStore;

    return (
      <MediaContainer width="100%">
        {showDiscount && (
          <CardDiscount imageUrl={data?.thumbnail_url}>
            {`${discountPercent}% OFF`}
          </CardDiscount>
        )}
        {data?.thumbnail_url && (
          <div className="tw-relative tw-h-full tw-w-full">
            <NextImage
              className="tw-h-full tw-w-full tw-object-contain"
              property="image"
              loading="lazy"
              decoding="async"
              src={getImageUrlFromCompressedImages(compressedImages, cardImageUrl, {
                maxImgSize: getMaxImgSizeForComponent(componentTypeEnums.CARD),
              })}
              layout="fill"
              quality={isMobile ? 75 : 100}
              alt={`Image ${data?.name || 'available Items'}`}
            />
          </div>
        )}
      </MediaContainer>
    );
  };

  return oosStatus === 0 || data?.available ? (
    <CardContainer
      cardWidth={cardWidth}
      isAvailable={data?.available}
      isB2bStore={isB2bStore}
      reactSlick={props.reactSlick}
      categoryCard={showCategoryCard}
      imageUrl={data?.thumbnail_url}
      // style={{
      //   boxShadow:
      //     premium === 0 && theme.is_demo === 0 ? '0 2px 6px #4a4a4a' : '',
      // }}
      onClick={(e) => {
        const func = props?.onItemClick || onItemClick;
        func(data);
      }}
      ref={cardRef}
    >
      <CardBody>
        {canShowPDPSystem(theme?.theme_class) ? (
          <Link href={getLink(data, getRoute) as string}>{renderCard()}</Link>
        ) : (
          renderCard()
        )}
        {!isWishlistCard && !noTags && data?.tags?.length > 0 && (
          <CardTags padding={premium === 0 ? '4px 6px' : '8px 0 0px'}>
            {data?.tags?.map(
              (tag) =>
                tag.is_active !== 0 && (
                  <CardTag backgroundColor={tag.tag_color} key={tag.id}>
                    {tag.name}
                  </CardTag>
                )
            )}
          </CardTags>
        )}
        <div 
          className="tw-absolute tw-top-[7px] tw-right-[4px] tw-z-1 tw-rounded-[100%]"
          onClick={(e) => {
            e.stopPropagation();
            if (onWishlistDeleteClick) onWishlistDeleteClick(data?.id);
            else handleToggleWishlistClick(data?.id);
          }}
        >
          {(isWishlistCard ? <CloseIconWhiteBackground /> : <WishlistHeartButton isActive={isItemWishlisted} />)}
        </div>
        <CardMain
          imageUrl={data?.thumbnail_url}
          padding={
            theme?.custom_theme_flag ? '12px 0 0' : premium === 0 ? '4px 6px' : '4px 0 0'
          }
        >
          <CardData>
            <CardTitle
              fontColor={props.builderOverrideStyles?.textColor || '#000'}
              categoryCard={showCategoryCard}
              property="name"
               isWishlistCard={isWishlistCard}
            >
              {data?.name || 'Available Items'}
            </CardTitle>
            {!!data?.available && checkForLimitedQuantity(data) && !isB2bStore && (
              <CardInventory className="highlighter-red-color">
                Limited Stock Left
              </CardInventory>
            )}
            {!showCategoryCard && (
              <div>
                <CardPrice>
                  {isB2bStore ? (
                    <AmountDiscounted
                      fontColor={
                        props.builderOverrideStyles?.textColor ||
                        theme?.colors?.primary_color
                      }
                    >
                      {data?.b2b_pricing_info?.price_range || 'Price on Request'}
                    </AmountDiscounted>
                  ) : (
                    <>
                      <AmountDiscounted
                        fontColor={
                          props.builderOverrideStyles?.textColor ||
                          theme?.colors?.primary_color
                        }
                      >
                        <span>₹</span>
                        <span>{data?.discounted_price}</span>
                      </AmountDiscounted>
                      {data?.discounted_price !== data?.price && (
                        <AmountActual
                          fontColor={
                            props.builderOverrideStyles?.textColor
                              ? hexToRgba(props.builderOverrideStyles?.textColor, 0.7)
                              : 'rgba(0, 0, 0, 0.3)'
                          }
                        >
                          ₹{data?.price}
                        </AmountActual>
                      )}
                    </>
                  )}
                </CardPrice>
              </div>
            )}
          </CardData>
          {!isWishlistCard && services?.store_flag !== 0 &&
            !!data?.available &&
            props.showButton &&
            !isB2bStore && (
              <ButtonContainer>
                <Button
                  disableAddition={itemQuantityValueComparison(
                    cartData.items[itemIndexInCart]
                  )}
                  hasVariant={hasVariant}
                  fontSize="14"
                  onChange={handleAddRemoveItem}
                  quantity={
                    itemIndexInCart >= 0 ? cartData.items[itemIndexInCart].quantity : 0
                  }
                  hasScheduler={hasScheduler}
                />
                {hasVariant && (
                  <div className="variant--count-icontext">
                    <img
                      loading="lazy"
                      src="https://cdn.dotpe.in/longtail/themes/8073865/FcwGogkZ.webp"
                    />
                    {props.data?.variants_count} options
                  </div>
                )}
              </ButtonContainer>
            )}
          {!showCategoryCard && !imageUrl && discountPercent > 0 && !isB2bStore && (
            <CardDiscount>{`${discountPercent}% OFF`}</CardDiscount>
          )}
        </CardMain>
        {!hasRating && !isWishlistCard && (
          <OfferAvailableTag productInfo={data} customClasses="tw-mt-[8px]" />
        )}
        <div className={hasRating ? 'pv8px' : ''}>
          <RatingBox
            isVisible={hasRating && !isWishlistCard}
            rating={
              data?.store_item_review_rating?.review_rating &&
              data?.store_item_review_rating?.review_rating[0]?.avg_rating
            }
            ratingsCount={
              (data?.store_item_review_rating?.review_rating &&
                data?.store_item_review_rating?.review_rating[0]?.ratings_count) ||
              data?.store_item_review_rating?.ratings_count
            }
            productInfo={data}
            ratingCountColor={props.builderOverrideStyles?.textColor}
          />
        </div>
        <div className={premium === 0 && 'ph2 pb2'} property="description">
          {!data?.available && !isB2bStore ? (
            <CardDescription
              fontColor={
                props.builderOverrideStyles?.textColor
                  ? hexToRgba(props.builderOverrideStyles?.textColor, 0.6)
                  : '#9c9c9c'
              }
            >
              Out of stock
            </CardDescription>
          ) : (
            !showCategoryCard &&
            data?.description && !isWishlistCard && (
              <CardDescription
                fontColor={
                  props.builderOverrideStyles?.textColor
                    ? hexToRgba(props.builderOverrideStyles?.textColor, 0.6)
                    : '#9c9c9c'
                }
                isAvailable={!!data?.available}
              >
                {removeTagsAndReturn(data?.description)}
              </CardDescription>
            )
          )}
        </div>
        {isWishlistCard && 
        <div>
          {services?.store_flag !== 0 &&
            props.showButton && (data?.available || isNotifyProductEnabled()) &&
            !isB2bStore && (
              <ButtonContainer isWishlistCard = {isWishlistCard}>
                <Button
                  px="20px"
                  py="12px"
                  label={data?.available ? "Move to Cart" : "Notify Me"}
                  roundness = {2}
                  isWishlistCard={isWishlistCard}
                  itemInventryStatus = {data?.available}
                  disableAddition={itemQuantityValueComparison(
                    cartData.items[itemIndexInCart]
                  )}
                  hasVariant={hasVariant}
                  fontSize="14"
                  onChange={handleAddRemoveItem}
                  quantity={
                    itemIndexInCart >= 0 ? cartData.items[itemIndexInCart].quantity : 0
                  }
                  hasScheduler={hasScheduler}
                />
              </ButtonContainer>
            )}
        </div>}
      </CardBody>
    </CardContainer>
  ) : null;
};
